<template>
  <div v-if="dataPreReady" class="pdf-container-organizational-violence">
    <div v-if="dataReady" id="dataReady" />
    <div id="pdf-page-1" class="pdf-page">
      <div class="logo">
        <div class="d-flex justify-content-center">
          <img
              :src="
                '/static/images/unpd/unpd_logo_white_en.svg'
              "
              height="200"
              style="margin: 0px -45px 0 0"
          />
          <img
            :src="'./static/images/GES_Logo-White.svg'"
            height="260"
            style="margin-top: -30px;"
          />
        </div>
      </div>
      <div class="info-company">
        <div class="info-header">
          <div>
            <h3
              v-if="getBusiness.selfAssessment_general_business_companyName"
              id="companyName"
            >
              {{ getBusiness.selfAssessment_general_business_companyName }}
            </h3>
            <h4>{{ $t("label_reports_violenceSurvey_title") }}</h4>
            <h5>{{ $t("label_reports_date_caption") }} {{ today }}</h5>
          </div>
        </div>
      </div>
    </div>
    <div id="pdf-page-2" class="pdf-page pdf-page-flex resume">
      <!--      <div class="sidebar">
        <div>
          <h4>{{ $t('label_reports_genderGap_title') }}</h4>
          <h3 v-if="getBusiness.selfAssessment_general_business_companyName">
            {{ getBusiness.selfAssessment_general_business_companyName }}
          </h3>
          <h5>{{ $t('label_reports_date_caption') }} {{ today }}</h5>
        </div>
      </div>-->
      <div class="content-summary">
        <div>
          <b-row style="margin-bottom: 10px">
            <b-col sm="9" style="padding-right: 10px">
              <b-card
                :title="$t('label_violenceSurvey_indicator_ovi_nameAcronym')"
                :style="{ minHeight: '165px' }"
              >
                <b-row>
                  <b-col sm="9">
                    <p class="card-text">
                      {{ $t("label_violenceSurvey_indicator_ovi_description") }}
                    </p>
                  </b-col>
                  <b-col sm="3">
                    <div
                      v-if="generalIndex"
                      id="generalIndex"
                      class="general-index center-block"
                      :class="
                        generalIndex >= 60
                          ? generalIndex > 85
                            ? 'positive'
                            : 'intermediate'
                          : 'negative'
                      "
                    >
                      {{
                        generalIndex
                          | currency("", 0, { thousandsSeparator: "" })
                      }}%
                    </div>
                    <div
                      v-if="!generalIndex"
                      class="general-index center-block negative"
                    >
                      0%
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col sm="3" style="padding-left: 10px">
              <card-conventions
                height="165px"
                :show-ideal="false"
                :show-company="false"
              />
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 10px">
            <b-col sm="6" style="padding-right: 5px">
              <card-chart-gauge-organizational-violence
                v-if="indicators"
                :data="kemData"
                alias="kem"
                :small-font="true"
                :report="true"
                :calculated-height="minHeight"
                @minHeight="setMinHeight"
              />
            </b-col>
            <b-col sm="6" style="padding-left: 5px">
              <card-chart-gauge-organizational-violence
                v-if="indicators"
                :data="torData"
                alias="tor"
                :small-font="true"
                :report="true"
                :calculated-height="minHeight"
                @minHeight="setMinHeight"
              />
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 10px">
            <b-col sm="6" style="padding-right: 5px">
              <card-chart-gauge-organizational-violence
                v-if="indicators"
                :data="kiaData"
                alias="kia"
                :small-font="true"
                :report="true"
                :calculated-height="minHeight"
                @minHeight="setMinHeight"
              />
            </b-col>
            <b-col sm="6" style="padding-left: 5px">
              <card-chart-gauge-organizational-violence
                v-if="indicators"
                :data="pvaData"
                alias="pva"
                :small-font="true"
                :report="true"
                :calculated-height="minHeight"
                @minHeight="setMinHeight"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardChartGaugeOrganizationalViolence from "./cards/CardChartGaugeOrganizationalViolence";
import { axiosCall } from "../utils/axiosCall";

export default {
  name: "ReportsOrganizationalViolencePdf",
  components: { CardChartGaugeOrganizationalViolence },
  data: function () {
    return {
      minHeight: 0,
      today: "",
      dataReady: false,
      dataPreReady: false,
      indicators: null,
      generalIndex: 0,
      kemData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_kem_acronym",
        description: "label_violenceSurvey_indicator_kem_description",
        title: "label_violenceSurvey_indicator_kem_nameAcronym",
      },
      torData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_tor_acronym",
        description: "label_violenceSurvey_indicator_tor_description",
        title: "label_violenceSurvey_indicator_tor_nameAcronym",
      },
      kiaData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_kia_acronym",
        description: "label_violenceSurvey_indicator_kia_description",
        title: "label_violenceSurvey_indicator_kia_nameAcronym",
      },
      pvaData: {
        ranges: {
          negMin1: 0,
          negMax1: 59.9999,
          interMin1: 60,
          interMax1: 83.9999,
          posMin1: 84,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_pva_acronym",
        description: "label_violenceSurvey_indicator_pva_description",
        title: "label_violenceSurvey_indicator_pva_nameAcronym",
      },
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getBusiness", "getCurrentSnapshot"]),
  },
  async created() {
    if (this.$route.params.lang) {
      await this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
  },
  async mounted() {
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.business,
    };
    var snapshot = {
      snapshotId: this.$route.params.snapshot,
    };
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    await this.$store.commit("authSuccess", auth);
    await this.$store.commit("setBusiness", business);
    await this.$store.commit("setCurrentBusiness", business);
    await this.$store.commit(
      "setAccountRole",
      this.$route.params.accountroleid
    );

    await this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
    await this.$store.commit("setSnapshots", [snapshot]);
    await this.$store
      .dispatch("PILLARS_GET")
      .then(() => {
        this.createPagination();
      })
      .catch((err) => {
        console.log(err);
      });

    await axiosCall({
      url: `ViolenceSurveys/organizationalViolenceReport/${this.getCurrentSnapshot.snapshotId}`,
      method: "GET",
    }).then((indicators) => {
      this.indicators = indicators.data;
      this.generalIndex = Math.round(indicators.data.ovi, 0);
      this.kemData.value = Math.round(indicators.data.kem, 0);
      this.torData.value = Math.round(indicators.data.tor, 0);
      this.kiaData.value = Math.round(indicators.data.kia, 0);
      this.pvaData.value = Math.round(indicators.data.pva, 0);
    });

    this.dataPreReady = true;
    setTimeout(() => {
      this.dataReady = true;
    }, 6000);
  },
  methods: {
    setMinHeight(minHeight) {
      if (this.minHeight < minHeight) {
        this.minHeight = minHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
$pdf-width: 298mm;
$pdf-height: 210.34mm;
$pdf-sidebar: 185px;
.pdf-container-organizational-violence {
  float: none;
  #pdf-page-1 {
    background-color: $primary-color;
  }
  .pdf-page {
    width: $pdf-width;
    height: $pdf-height;
    position: relative;
    border: none;
    overflow: hidden;

    .page-number {
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 100;
      font-size: 0.8rem;
      border-radius: 50%;
      border: 1px solid #949290;
      width: 1.5rem;
      height: 1.5rem;
      text-align: center;
      background-color: #fff;
    }
  }

  .info-company {
    background-color: #ffffff;
    padding: 90px 0;
    color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;

    h3 {
      font-size: 3.5rem;
      font-family: $font-title;
      padding-top: 50px;
      text-transform: uppercase;
      color: $primary-color;
    }

    h4 {
      font-size: 25px;
      font-family: $font-subtitle;
      text-transform: uppercase;
      color: $primary-color;
      text-align: center;
    }

    h5 {
      font-size: 25px;
      color: $primary-color;
      font-family: $font-subtitle;
      text-align: center;
    }
  }

  .pdf-page-flex {
    display: flex;
  }

  .content {
    padding: 10px;
    width: 975px;
    display: flex;

    .conventions {
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      width: 180px;
    }

    .chart {
      width: 755px;
      margin-left: 20px;
    }

    .radar {
      width: 50%;
      margin-right: 10px;
    }

    .resume {
      width: 50%;
    }
  }

  .sidebar {
    display: flex;
    align-content: center;
    padding: 57px;
    background-color: $primary-color;
    height: 100%;
    width: 482px;
    flex-wrap: wrap;
    color: #ffffff;

    h3 {
      font-size: 40px;
      font-family: $font-title;
      text-transform: uppercase;
    }

    h4 {
      font-size: 25px;
      font-family: $font-subtitle;
      text-transform: uppercase;
    }

    h5 {
      font-size: 25px;
      font-family: $font-subtitle;
    }

    &.second-color {
      background-color: $primary-color;
    }

    .middle {
      width: 100%;
    }

    .bottom {
      width: 100%;
    }
  }

  .content-indicator {
    padding: 10px;
    width: 975px;
    display: flex;
    flex-direction: column;

    .block {
      width: 932px;
      display: flex;
      padding-bottom: 10px;
    }

    .content-card {
      width: 456px;
      height: 365px;
      margin-right: 10px;
    }

    .content-card-double {
      width: 100%;
      height: 365px;
      margin-right: 10px;
    }

    .conventions-2 {
      width: 25%;
    }
  }

  .logo {
    padding-top: 50px;
    height: 250px;
    padding-right: 65px;
  }

  .info-company {
    height: 480px;
    background-color: #f5fafd;
    color: $primary-color !important;
    text-transform: uppercase;
    padding: 90px 0;
    height: 450px;
    margin-top: 50px;
  }

  .indicator-page .indicator-label {
    width: 88px;
    height: 88px;
    color: #fff;
    border-radius: 100%;
    border: 6px solid #fff;
    margin: 0 auto;
    font-size: 28px;
    font-family: $font-subtitle;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      margin: 0;
    }
  }

  .content-summary {
    padding: 10px;
    width: 100%;

    .conventions {
      display: flex;
    }

    .general-index-container {
      width: 75%;
      margin-right: 10px;
    }

    .conventions-container {
      width: 25%;
    }

    .chart {
      .card {
        margin-top: 5px;
      }
    }
  }

  .conventions-disclaimer {
    font-family: $font-subtitle;
    font-size: 1rem;
  }
}

.indicators-list {
  font-family: $font-text;
  font-size: 0.8rem;
  margin-top: 5px;
  text-align: justify;
  width: 100% !important;

  th {
    text-transform: uppercase;
    background-color: #414141;
    color: #fff;
    font-family: $font-subtitle;
    width: 100% !important;
  }

  tr {
    border: 1px solid #414141;
  }
}

.general-index {
  font-size: 3rem;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.col-8 {
  padding-right: 5px;
}

.col {
  padding-left: 5px;
}

.card {
  margin-top: 0px;

  .card-body {
    padding: 0.5rem;
  }

  .card-text {
    font-size: 0.8rem;
  }
}
.info-header {
  display: flex;
  justify-content: center;
}
</style>

